import { render, staticRenderFns } from "./login-box.vue?vue&type=template&id=77ffabdc&scoped=true"
import script from "./login-box.js?vue&type=script&lang=js&external"
export * from "./login-box.js?vue&type=script&lang=js&external"
import style0 from "./login-box.less?vue&type=style&index=0&id=77ffabdc&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ffabdc",
  null
  
)

export default component.exports